define("settings/components/social-identity/sort-profiles", ["exports", "@ember/component", "@ember/object/computed", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _computed, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object/computed",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{yield (hash orderedProfiles=this.orderedProfiles)}}
  */
  {
    "id": "PEtcguw7",
    "block": "[[[18,1,[[28,[37,1],null,[[\"orderedProfiles\"],[[30,0,[\"orderedProfiles\"]]]]]]]],[\"&default\"],false,[\"yield\",\"hash\"]]",
    "moduleName": "settings/components/social-identity/sort-profiles.hbs",
    "isStrictMode": false
  });

  /**
   * @module Components
   */
  let SortProfilesComponent = _exports.default = (_dec = (0, _computed.sort)('args.profiles', function (a, b) {
    if (this.defaultSorting.indexOf(a.profileType) > this.defaultSorting.indexOf(b.profileType)) {
      return 1;
    } else if (this.defaultSorting.indexOf(a.profileType) < this.defaultSorting.indexOf(b.profileType)) {
      return -1;
    }
  }), (_class = class SortProfilesComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "defaultSorting", ['instagram', 'facebook', 'twitter', 'pinterest', 'tiktok']);
      _initializerDefineProperty(this, "orderedProfiles", _descriptor, this);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "orderedProfiles", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SortProfilesComponent);
});